export default [
  {
    path: "/",
    redirect: "/home/",
  },
  {
    path: "/exam/",
    component: () => import("@/pages/exam/Exam.vue"),
  },
];
